module.exports = __webpack_public_path__ + "static/media/first.acd71b1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/first.svg
// module id = 202
// module chunks = 0